// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"418":"a103bc84","461":"05a8617f","489":"2ef5d769","731":"3d6f4234","980":"5401fb75"}[chunkId] + ".css";
};